module.exports = __webpack_public_path__ + "img/jiaoyanzu_bg.16314d9d.png";